import Constants from 'us.collection.case/constants';
import { IAPIAction } from 'us.collection/interfaces';

const {
	GET_DEBTOR_WIDGET_DATA,
	GET_DEBTOR_WIDGET_DATA_FAIL,
	GET_DEBTOR_WIDGET_DATA_SUCCESS,
} = Constants.ACTIONS.DebtorWidget;

export const DebtorWidgetActions: IAPIAction = {
	debtorWidget: {
		get: (data) => ({
			type: GET_DEBTOR_WIDGET_DATA,
			payload: {
				data: data,
				isLoading: true,
			},
		}),
		success: (data) => ({
			type: GET_DEBTOR_WIDGET_DATA_SUCCESS,
			payload: {
				data: data,
				isLoading: false,
			},
		}),
		fail: (error) => ({
			type: GET_DEBTOR_WIDGET_DATA_FAIL,
			payload: {
				error: error,
				isLoading: false,
			},
		}),
	},
};
